/**
 * 全局枚举类型 
 */

/**
 * 模块枚举类型 
 */
export enum EnumModule {
    ClinicalTrialFirst = 1,    //临床试验-慢病项目课题一 (首次入组)  
    ClinicalTrialDiag = 2,     //临床试验-慢病项目课题一 (已入组，再次随诊实施) 
    Other = 9                  //其他 
}

/**
 * 流程枚举类型 
 */
export enum EnumFlow {
    FirstDiagnosis = 1,    //首诊流程  
    ExecuteDiagnosis = 2   //随诊实施流程  
}
/**
 * APP枚举类型 
 */
export enum EnumApp {
    Android = 1,    //Android
    IOS = 2,        //IOS
    Other = 3       //其他
}

/**
 * 设备详细枚举类型 
 */
export enum EnumDevice {
    android_mobile = 11,    //Android 手机
    android_tablet = 12,    //Android 平板电脑
    android_phablet = 13,   //Android 平板手机 
    android_other = 19,     //Android 其他设备 
    iphone = 21,            //iphone
    ipad = 22,              //ipad
    ios_other = 29,         //ios 其他设备
    other = 31              //Android和IOS平台以外的设备 
}
/**
 * 密码枚举类型 
 */
export enum EnumPassword {
    OldPassword = 1,        //旧密码  
    NewPassword = 2,        //新密码  
    NewPasswordAgain = 3    //新密码确认  
}

/**
 * 页面枚举类型 
 */
export enum EnumPage {
    Login = 1,        //登录  
    Register = 2,     //注册  
    FindPassword = 3  //密码找回  
}


